const doc = [({"en":({"js":({"admin":({"highscore_regions":({"table":({"the_region_was_removed_from_the_highscore":"The region was removed from the highscore"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;